module.exports = __webpack_public_path__ + "0acfa4c42e93a12c4d1429f9f8b770df.svg";


//////////////////
// WEBPACK FOOTER
// ./images/logo_cabin_mobile.svg
// module id = 212
// module chunks = 0